import React from 'react';
type MonogramPatternProps = {
  className?: string;
};
const SLOPE = 2.15;
const LAYERS = [0, 1, 2, 3, 4, 5];
export function MonogramPattern({
  className = ''
}: MonogramPatternProps) {
  return <svg viewBox="0 0 600 600" fill="none" aria-hidden="true" preserveAspectRatio="xMidYMid meet" className={className} data-id="element-35" data-mp="iq8u6ifrwq0b">
      {LAYERS.map(i => {
      const apexY = 40 + i * 62;
      const halfBase = (600 - apexY) / SLOPE;
      return <path key={i} d={`M${300 - halfBase} 600 L300 ${apexY} L${300 + halfBase} 600`} stroke="currentColor" strokeOpacity={1 - i * 0.15} strokeWidth="1" vectorEffect="non-scaling-stroke" data-id="element-36" data-mp="16g35gvkg26ig" />;
    })}
      <path d={`M${300 - (400 - 40) / SLOPE} 400 H600`} stroke="currentColor" strokeWidth="1" vectorEffect="non-scaling-stroke" data-id="element-37" data-mp="3n4ywef7pgdi9" />
    </svg>;
}